import ActText from "./inputTextSth";
import $ from 'jquery'
export let activiti;
export let actChoose = new  ActChoose();
export let actText = new  ActText();
export let actData = new ActData();


let optionsCopy = {};

let defaultOptions = {
    id: "#xxx", //渲染选择器
    uuid:"",   //主键id
    userAccount: "",
    againFlag: false,
    activitiConf: {    //流程查询配置
        treeContentId: "",
        activitiTypeEnum: "",
        mediaCode: "",
    },
    showAfterFuns: {   //按钮加载前置js

    },
    success : function(activiti){   //对象创建成功回调
    },
    isStart : false,
    otherJs : {     //前置js 方法集合

    },
    againFunction :function (call){
        call();
    }
};

export function Activiti (options){
    //初始化配置
    this.options = options;
    //将初始化配置存储 以待后续使用
    optionsCopy = Activiti.util.deepClone(this.options);
    this.buttonList = [];
    this.actForm = { //表单信息
        values:{},
        users:{}
    };
    this.actTask = {};
    this.activitiData = {//流程信息
        deploymentKey : "",
    }
};

let urlConf = {
    loadButtonListUrl : "/cm-sites-activiti/activiti/getButton",
    actSubmitUrl : "/cm-sites-activiti/activiti/submitForm",
    actButtonConfig : "/cm-sites-activiti/activitiButtonConfig/getActButtonConfig",
    actStartFromUrl : "/cm-sites-activiti/activiti/getStartFrom",
    actFromUrl : "/cm-sites-activiti/activiti/getFormUrlById",
    actGetTaskIdUrl : "/cm-sites-activiti/activitiAdmin/getTaskIdByProcessInstanceId",
    actTodoListUrl : "/cm-sites-activiti/activiti/getNeedProcessed",
    actTodoAllListUrl : "/cm-sites-activiti/activiti/getNeedProcessedAll",
    getActServiceDataByIdUrl : "/cm-sites-activiti/activiti/getActServiceDataByIdUrl",
    actExaminedUrl : "/cm-sites-activiti/activiti/examined",
    actHistoryUrl : "/cm-sites-activiti/activiti/getActHistory",
    actTaskFormUrl : "/cm-sites-activiti/activiti/getTaskForm",
    terminateUrl : "/cm-sites-activiti/activitiAdmin/terminateByProcessInstanceId",
    dropProcessInstanceUrl : "/cm-sites-activiti/activitiAdmin/dropProcessInstance",
    getActserviceDataByUuidUrl : "/cm-sites-activiti/activiti/getActserviceDataByUuid",
    updateServiceDataUrl : "/cm-sites-activiti/activiti/updateServiceData",
    loadButtonFun :{},
}

/**
 *
 * @param options
 id: "#xxx", //渲染选择器
 uuid:"",   //主键id
 activitiConf: {    //流程查询配置
            treeContentId: "",
            activitiTypeEnum: "",
            mediaCode: "",
        },
 showAfterFuns: {   //按钮加载前置js

    }
 * @param call
 * @returns {{}}
 */
Activiti.createActivit = function(options,call){
    //拷贝默认配置
    let copyOption = Activiti.util.deepClone(defaultOptions);
    //合并配置
    copyOption = Object.assign(copyOption,options);
    //初始化
    activiti = new Activiti(copyOption);
    //是不是只查询，如果是 则不需要加载按钮  直接返回
    if(activiti.options.queryOnly == true){
        call.call(activiti);
        return;
    }
    //调用对象创建成功的方法
    activiti.options.success(activiti);
    activiti.init(function(){
        activiti.getRemarks();
        call.call(activiti);
    });
}

/**
 * 更新流程库中的数据主体，不会修改历史记录中的数据
 * @param param
 * @param call
 */
Activiti.prototype.updateServiceData = function (param,call) {
    if(param && (param.uuid || activiti.options.uuid)){
        param.uuid = activiti.options.uuid;
        activiti.post(urlConf.updateServiceDataUrl,JSON.stringify(param),function(res){
            if(res && res.code == 200){
                call({code:1,log:res.msg})
            }else if(res){
                call({code:-1,log:res.msg})
            }else{
                call({code:-1,log:"请求错误"})
            }
        })
    }else{
        call({code: -1, log:"参数中或流程初始化数据中必须包含uuid参数"})
    }
}

Activiti.prototype.getRemarks = function(){
    if(activiti.activitiData.processInstanceId){
        activiti.getTaskList(activiti.activitiData.processInstanceId,function(taskList){
            if(taskList && taskList instanceof Array && taskList.length > 1 ){
                let remarksId = taskList[taskList.length - 2].id;
                if(taskList[taskList.length-1].endTime){
                    remarksId = taskList[taskList.length - 1].id
                }
                activiti.getFrom(remarksId,function(thisForm){
                    if(thisForm == undefined || thisForm.fields == undefined || thisForm.fields.length == 0){
                        return;
                    }
                    thisForm.fields.forEach(function (item,index) {
                        if(item.id == "otherData" && item.value && item.value.length > 0){
                            let otherData = JSON.parse(item.value);
                            if(otherData != null &&  otherData.hasOwnProperty("remarks")){
                                activiti.showRemarks(Activiti.util.escape(otherData.remarks));
                            }
                        }
                    })
                });
            }
        });
    }
}


Activiti.prototype.load = {
    layerLoadIndexArray : [],
    start : function(){
        this.end();
        // this.layerLoadIndexArray.push(layer.load());
    },
    end : function(){
        // $.each(this.layerLoadIndexArray,function(index,object){
        //     layer.close(object);
        // })
    }
}

Activiti.prototype.buttonShow = (btn) => {
    // $(btn).show();
    console.log(btn)
};

Activiti.prototype.bindClick = function(btn, that, item,fun) {
    btn.addEventListener("click", function () {
        activiti.options.item = item;
        fun.call(that)
    });
}

Activiti.prototype.render = function(buttons = [],call){
    // activiti.buttonList = [];
    // //排序
    // buttons.sort(function(bt1,bt2){
    //     return bt1.sort - bt2.sort;
    // })
    // let args = [];
    // //创建 button
    // $.each(buttons,function (index,item) {
    //     let btn = document.createElement("button");
    //     $(btn).attr("class",activiti.options.class);
    //     $(btn).attr("type","button");
    //     $(btn).html(item.name);
    //     $("" + activiti.options.id).append(btn);
    //     activiti.buttonList.push(btn);
    //     //前置js
    //     if(item.document && item.document.lineJavaScript && item.document.lineJavaScript.afterButtonShow && activiti.options.showAfterFuns[item.document.lineJavaScript.afterButtonShow]){
    //         $(btn).hide();
    //         let func = eval(activiti.options.showAfterFuns[item.document.lineJavaScript.afterButtonShow]);
    //         new func(item,function(res){
    //             if(res){
    //                 activiti.buttonShow(btn);
    //             }
    //         });
    //     }
    //     if(item.document.lineJavaScript.otherJs && item.document.lineJavaScript.otherJs.split(",").length > 0){
    //         let funArray = item.document.lineJavaScript.otherJs.split(",");
    //         $.each(funArray,function fn(i,it){
    //             let funtemp = function(){
    //                 let callback = Activiti.util.getCallbackFn.call(funtemp);
    //                 let func = activiti.options.otherJs[funArray[i]];
    //                 if(func){
    //                     func.call(that,that,item,function(res){
    //                         if(res){
    //                             callback.call(that,item)
    //                         }else{
    //                             activiti.error(res || "执行出错！");
    //                         }
    //                     })
    //                 }else{
    //                     activiti.error("未找到前置js：" + funArray[i] + ",请清除浏览器缓存重试。如清理缓存后问题依然存在，请联系管理员。")
    //                 }
    //             }
    //             args.push(funtemp);
    //         })
    //     }
    //     args.push(function(){
    //         activiti.buttonClick.call(activiti,item)
    //     });
    //     activiti.bindClick(btn,that,item,function(){
    //         Activiti.util.simpleChainedFn.apply(that, args);
    //     })
    // });
    // call.call(that);
}

Activiti.prototype.error = function(res) {
    // if(typeof res === "string"){
    //     layui.layer.alert(res, {icon: 2,closeBtn: 0 });
    // }else if(res.msg){
    //     layui.layer.alert(res.msg, {icon: 2,closeBtn: 0 });
    // }
};

Activiti.prototype.log = function(res) {
    if(typeof res === "string"){
        console.log(res)
    }
}

Activiti.prototype.successMsg = function(res,call) {
    // if(typeof res === "string"){
    //     layui.layer.alert(res, {icon: 1,closeBtn: 0 }, function () {
    //         call()
    //     });
    // }else if(res.msg){
    //     layui.layer.alert(res.msg, {icon: 1,closeBtn: 0 }, function () {
    //         call()
    //     });
    // }
}


/**
 * 按钮点击事件
 * @param index
 */
Activiti.prototype.buttonClick = function(item) {
    //从按钮列表中获取按钮配置
    let actButton = item;
    //设置表单数据中选择数据为当前按钮名称
    this.actForm.values.choose = item.btnName || item.name;
    this.options.statusNameTemp = item.name;
    if(item &&  item.document  && item.document.lineJavaScript ){
        let lineJavaScript = item.document.lineJavaScript;
        item.auditorMap = lineJavaScript.auditorMap;
        this.actForm.users = item.auditorMap;
        //是否需要调用外部接口
        if(lineJavaScript.url != undefined && lineJavaScript.url.length > 0){
            this.actForm.values.url = lineJavaScript.url;
        }
        //需要选人
        if(lineJavaScript.needAuditor == true){
            this.needAuditor = lineJavaScript.needAuditor;
            this.chooseAuditor(lineJavaScript.auditorMap);
        }//需要审核意见
        else if(lineJavaScript.needRemarks == true){
            this.needRemarks = lineJavaScript.needRemarks;
            actText.getText({title:"备注"},"remarks",this.chooseDone);
        }else if(lineJavaScript.auditorMap != undefined){
            this.chooseDone(lineJavaScript.auditorMap);
        }else {
            //什么都不选
            this.onlySubmit();
        }
    }
}


Activiti.prototype.doSubimt = function() {
    if (activiti.activitiData.processInstanceId != null) {
        //获取taskId
        activiti.getTaskList(activiti.activitiData.processInstanceId, function (taskList) {
            //设置节点id
            activiti.actTask.lastId = taskList[taskList.length - 1].id;
            //设置表单id
            activiti.actForm.id = taskList[taskList.length - 1].id;
            //根据最后一个节点id 获取当前表单
            activiti.getFrom(activiti.actTask.lastId, function (requestData) {
                //设置表单id
                activiti.actForm.formId = requestData.formId;
                //设置节点id
                activiti.actTask.lastId = requestData.id;
                activiti.submit();
            });
        });
    }
}

Activiti.prototype.onlySubmit = function(){
    if(!activiti.options.isStart){
        activiti.afterSave(activiti, function(res){
            if(res){
                res.statusName = activiti.options.statusNameTemp;
                activiti.actForm.values.serviceData = {};
                activiti.actForm.values.serviceData.uuid = res.uuid;
                activiti.actForm.values.serviceData.data = res;
                // activiti.actForm.values.serviceData.data = Activiti.util.encodeBase64(res);
                activiti.doSubimt.call(activiti);
            }
        });
    }else{
        activiti.doSubimt.call(activiti);
    }

}

Activiti.prototype.getFrom = function(taskId,call){
    this.post(urlConf.actFromUrl,{id : taskId},call);
}

Activiti.prototype.getTaskList = function(processInstanceId,call,data){
    this.post(urlConf.actGetTaskIdUrl, {
        processInstanceId: processInstanceId
    },function(requestData){
        if(typeof call == 'function'){
            call(requestData.data,processInstanceId,data)
        }
    })
}

/**
 * 初始化 解析配置
 * @param options
 * @param call
 */
Activiti.prototype.init = function(call){
    //获取流程定义
    // if(this.options.uuid && !this.options.againFlag){
    if(this.options.uuid ){   
        this.getActivtiByUUID(this.options.uuid,function(res){
            //旧流程
            if(res.code == 200 && res.data) {
                activiti.activitiData = res.data;
                activiti.actForm.processInstanceId = res.data.processInstanceId;
                activiti.loadButtonList(call);
            }else{  //新流程
                activiti.initNew(call);
            }
        })
    }else{  //新流程
        this.initNew(call);
    }
}

Activiti.prototype.initByConf = function(call) {
    //获取流程定义
    if (activiti.options.activitiConf) {
        if (Activiti.util.isFunction(activiti.getActivitiKey)) {
            activiti.getActivitiKey(activiti.options.activitiConf, function (res) {
                activiti.activitiData.deploymentKey = res;
                activiti.loadButtonList(call);
            })
        }
    }
}

Activiti.prototype.initNew = function(call){
    if(this.options.againFlag && this.options.oldUuid){
        this.actForm.oldUuid = this.options.uuid;
        this.options.againFunction(activiti,function(){
            activiti.initByConf.call(activiti,call);
        })
    }else{
        this.initByConf.call(activiti,call);
    }
}

Activiti.prototype.cleanButton = function(call){
    if(activiti.buttonList.length > 0){
        // $.each(activiti.buttonList,function(index,item){
        //     $(item).remove();
        // })
        // activiti.buttonList = [];
    }
};

Activiti.prototype.reloadButton = function(call){
    activiti.cleanButton();
    activiti.initNew.call(activiti,call);
}

//选择完成后执行,组装参数
Activiti.prototype.chooseDone = function(choose) {
    activiti.load.start();
    if (choose.type == "activitiUsers" || choose.type == "users") {
        activiti.actForm.users = Object.assign(activiti.actForm.users, choose);
    } else if (choose.type == "remarks") {
        activiti.actForm.values.otherData = {};
        activiti.actForm.values.otherData = {"remarks": choose.remarks};
    }
    //新流程，先自推一次
    if (activiti.activitiData.processInstanceId == undefined || activiti.activitiData.processInstanceId == null) {
        //提交开始表单 获取流程id
        activiti.submitStart.call(activiti,function () {
            activiti.actForm.deploymentKey = activiti.activitiData.deploymentKey;
            activiti.onlySubmit.call(activiti);
        });
    } else {
        activiti.onlySubmit.call(activiti);
    }
}

Activiti.prototype.submitStart = function(call){
    activiti.options.isStart = true;
    this.afterSave(this,function(res){
        if(res){
            activiti.actForm.values.serviceData = {};
            activiti.actForm.values.serviceData.uuid = res.uuid;
            activiti.actForm.values.serviceData.data = res;
            //获取开始表单
            activiti.post(urlConf.actStartFromUrl,{
                deploymentKey: activiti.activitiData.deploymentKey
            },function(startData){
                activiti.activitiData.processDefinitionId = startData.processDefinitionId;
                //提交开始表单
                activiti.post(urlConf.actSubmitUrl,JSON.stringify({
                    processDefinitionId : activiti.activitiData.processDefinitionId,
                    deploymentKey : activiti.activitiData.deploymentKey,
                }),function(submitData){
                    //流程实例id
                    activiti.activitiData.processInstanceId = submitData.id;
                    if(typeof call == 'function'){
                        call(submitData.id);
                    }
                });
            });
        }
    });
}

/**
 * 需要页面重写 结束的方法
 * @param call
 */
Activiti.prototype.submitOK = function(call){

}

/**
 * 需要页面重写 推进成功后回调
 * @param call
 */
Activiti.prototype.endFunction = function(activiti,call){

}

/**
 * 需要页面重写 点击后的保存操作
 * @param call
 */
Activiti.prototype.afterSave = function(){

}

Activiti.prototype.submit = function(call){
    this.actForm.deploymentKey = this.activitiData.deploymentKey;
    this.actForm.processInstanceId = this.activitiData.processInstanceId;
    this.actForm.pojoName = this.options.pojoName;
    if(this.actForm.users.activitiUsers && this.actForm.users.activitiUsers.length > 0 ){
        this.actForm.users.FORM_SERVICE_USERS = [];
    }
    activiti.post(urlConf.actSubmitUrl,JSON.stringify(this.actForm),function(requestData){
        if(requestData.status != undefined && requestData.status == 200){
            activiti.endFunction(activiti,function(res){
                if(res && res.status === true){
                    if(activiti.actForm.values.url){
                        activiti.load.end();
                        activiti.successMsg("正在" + activiti.options.statusNameTemp + "中，可以在列表页查看发布进度。",function(){
                            activiti.submitOK.call(activiti);
                        })
                    }else if(activiti.options.statusNameTemp){
                        let layerMsg = activiti.options.statusNameTemp + '成功';
                        activiti.successMsg(layerMsg,function(){
                            activiti.submitOK.call(activiti);
                        })
                    }else{
                        activiti.load.end();
                        activiti.successMsg(requestData.msg,function(){
                            activiti.submitOK.call(activiti);
                        })
                    }
                }else if(res && res.msg){
                    activiti.error(res.msg);
                }else{
                    console.log("执行后置接口错误");
                }
            })
        }else if(requestData && requestData.status != undefined && requestData.status == 500){
            activiti.load.end();
            activiti.error({status:false,msg:requestData.msg})
        }else if(requestData == undefined){
            activiti.load.end();
            activiti.error("请求超时！内容已保存，请刷新重试");
        }else{
            activiti.load.end();
            activiti.error("流程推进失败！"+requestData.msg);
        }
    });

}


//加载按钮配置
Activiti.prototype.loadButtonList = function(call){
    activiti.post(urlConf.loadButtonListUrl, {
        processInstanceId : this.activitiData.processInstanceId || "",
        deploymentKey : this.activitiData.deploymentKey || ""
    },function(data){
        if(data && data.length > 0 ){
            activiti.render(data,call);
        }else{
            activiti.render([],call);
        }
    });

}

/**
 * 获取流程信息
 * @param uuid
 * @param call
 */
Activiti.prototype.getActivtiByUUID = function(uuid,call){
    this.post(urlConf.getActserviceDataByUuidUrl,{uuid:uuid},function(res){
        if(Activiti.util.isFunction(call)){
            call(res);
        }
    })
}

/**
 * 获取历史记录
 * @returns {*[]|*}
 */
Activiti.prototype.getHistory = function(call,inputUuid){
    let uuid,processInstanceId ;
    //外部指定，优先度最高
    if(inputUuid){
        uuid = inputUuid;
    }else if(this.options.oldUuid){ //历史重启
        uuid = this.options.oldUuid;
    }else if(this.actForm.processInstanceId || this.options.uuid){
        processInstanceId = this.actForm.processInstanceId ? this.actForm.processInstanceId : "";
        uuid = this.options.uuid || "";
    }else{
        call.call(this,[]);
        return;
    }
    let params = {}
    if(processInstanceId){
        params.processInstanceId = processInstanceId
    }
    if(uuid){
        params.uuid = uuid
    }
    this.post(urlConf.actHistoryUrl,params,function(requestData){
        if(typeof call == 'function'){
            call.call(activiti,requestData);
        }
    })
};

/**
 * 工具箱
 * @type {{post: post, isFunction: isFunction, timeFormat: timeFormat, escape: (function(*=): string), isJsonFormat: isJsonFormat}}
 */
Activiti.util = {
    timeFormat : function (time) {
        if (time == null || undefined)
            return "";
        let d = new Date(time);
        let year = d.getFullYear();       //年
        let month = d.getMonth() + 1;     //月
        let day = d.getDate();            //日

        let hh = d.getHours();            //时
        let mm = d.getMinutes();          //分
        let ss = d.getSeconds();           //秒
        let clock = year + "-";
        if (month < 10)
            clock += "0";
        clock += month + "-";
        if (day < 10)
            clock += "0";
        clock += day + " ";
        if (hh < 10)
            clock += "0";
        clock += hh + ":";
        if (mm < 10) clock += '0';
        clock += mm + ":";
        if (ss < 10) clock += '0';
        clock += ss;
        return (clock);
    },
    escape : function (t) {
        return String(t || "").replace(/&([a-zA-Z0-9]+;)/g, "&amp;$1").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;")
    },
    isFunction : function(funName){
        if(funName == undefined || funName == "")
            return false;
        if(typeof funName == "function")
            return true;
        if(typeof funName == "string"){
            try{
                if(typeof(eval(funName)) == "function")
                    return true;
            }catch(e){
                return false;
            }
        }
        return false;
    },
    isJsonFormat : function(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    },
    deepClone : function(source){
        let targetObj = source.constructor === Array ? [] : {}; // 判断复制的目标是数组还是对象
        for(let keys in source){ // 遍历目标
            if(source.hasOwnProperty(keys)){
                if(source[keys] && typeof source[keys] === 'object'){ // 如果值是对象，就递归一下
                    targetObj[keys] = source[keys].constructor === Array ? [] : {};
                    targetObj[keys] = this.deepClone(source[keys]);
                }else{ // 如果不是，就直接赋值
                    targetObj[keys] = source[keys];
                }
            }
        }
        return targetObj;
    },
    simpleChainedFn: function () {
        let localParam = arguments; //当前入参
        let firstFnArguments; //首节点的入参(数组格式)
        let chainLength = localParam.length; //除掉首节点入参，所有链条长度

        // 入参数据校验...
        for(let i=0;i<localParam.length;i++){
            if(!localParam[i] || typeof localParam[i] !== "function"){
                // 如果当前是倒是第二个，则认为是首节点的入参；链条长度减1...
                if(i === localParam.length - 1){
                    firstFnArguments = localParam[i];
                    chainLength -= 1;
                }else{
                    console.log("【error】链条参数有误！");
                    return;
                }

            }
        }
        // 组合链条...
        let firstFn = (function combinationFn(index){
            let curFnIndex = index || 0; //当前函数索引
            let callBack; //当前函数参数回调

            // 如果存在下一条，则将下一条绑定为当前的回调...
            if(curFnIndex + 1 <  chainLength){
                // callBack = arguments.callee(curFnIndex + 1);
                callBack = combinationFn(curFnIndex + 1);
            }

            let curFn = localParam[curFnIndex];
            if(curFn){
                if(callBack){
                    curFn.callback = callBack;
                }
                return curFn;
            }else{
                return false;
            }

        })();
        // 启动链条 ...
        if(typeof firstFn === "function"){
            let suctnParam = "";
            if(firstFnArguments){
                for(let i = 0 ; i < firstFnArguments.length; i ++)
                {
                    suctnParam += "firstFnArguments[" + i + "]" + (i === firstFnArguments.length - 1 ? "" : ",");
                }
            }
            eval("firstFn(" + suctnParam + ")");

        }
    },
    getCallbackFn : function(){
        return this.callback;
    },
    encodeBase64 : function (str){
        // 对字符串进行编码
        var encode = encodeURIComponent(str);
        // 对编码的字符串转化base64
        var base64 = btoa(encode);
        return base64;
    }
};

/**
 * 撤回功能
 * @param call
 */
Activiti.prototype.terminate = function(call){
    if(!this.activitiData.processInstanceId){
        activiti.error("流程信息获取失败：请刷新后重试！", {icon: 2,closeBtn: 0 });
        call(false);
    }
    activiti.post(urlConf.terminateUrl,{processInstanceId:this.activitiData.processInstanceId},function(data){
        if(typeof call == 'function'){
            if(data.code == 200){
                call(true);
            }else{
                activiti.error("流程提前结束失败：" + data.msg, {icon: 2,closeBtn: 0 });
                call(false);
            }
        }
    });
}

Activiti.prototype.chooseAuditor = function(auditorMap) {
    //如果是业务指定的人，则优先业务的人
    if(typeof this.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS != "undefind" && Array.isArray(this.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS) && this.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS.length >0)
        actChoose.getChoose.call(this,this.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS,"activitiUsers",this.chooseDone);
    //如果是指定人中选一个的，则列出人的列表
    else if(auditorMap.FORM_SERVICE_USERS.length > 0){
        auditorMap.FORM_SERVICE_USERS.map((item,index) =>{
            if(item && item.id == activiti.options.userAccount){
                auditorMap.FORM_SERVICE_USERS.splice(index,1);
                return;
            }
        });
        actChoose.getChoose.call(activiti,auditorMap.FORM_SERVICE_USERS,"users",this.chooseDone);
    }else if(auditorMap.FORM_SERVICE_GROUP.length > 0  && auditorMap.FORM_SERVICE_ROLE.length < 1){    //只选择部门
        actData.getUser({
            group:auditorMap.FORM_SERVICE_GROUP
        },activiti,function(users){
            actChoose.getChoose.call(activiti,users,"activitiUsers",activiti.chooseDone)
        })
    }else if(auditorMap.FORM_SERVICE_ROLE.length > 0 && auditorMap.FORM_SERVICE_GROUP.length < 1){     //只选择角色
        actData.getUser({
            role :auditorMap.FORM_SERVICE_ROLE
        },activiti,function(users){
            actChoose.getChoose.call(activiti,users,"activitiUsers",activiti.chooseDone);
        })
    }else if(auditorMap.FORM_SERVICE_GROUP && auditorMap.FORM_SERVICE_ROLE){      //选择角色和部门
        actData.getUser({
            role :auditorMap.FORM_SERVICE_ROLE,
            group :auditorMap.FORM_SERVICE_GROUP
        },activiti,function(users){
            actChoose.getChoose.call(activiti,users,"activitiUsers",activiti.chooseDone);
        })
    }
};


Activiti.prototype.todoList = function(query,call){
    this.post(urlConf.actTodoListUrl,JSON.stringify(query),function (todoList) {
        if(typeof call == 'function'){
            call(todoList);
        }
    });
}

Activiti.prototype.examinedList = function(query,call){
    this.post(urlConf.actExaminedUrl,JSON.stringify(query),function (examinedList) {
        if(typeof call == 'function'){
            call(examinedList);
        }
    });
};

Activiti.prototype.post = function(url,pram,call){
    let requestData ;
    let contentType =  'application/x-www-form-urlencoded';
    if(typeof pram == 'string'){
        contentType =  'application/json; charset=UTF-8';
    }
    $.ajax({
        url: url,
        data: pram,
        contentType: contentType,
        dataType:"JSON",
        traditional:true,
        type:"POST",
        success: function(result){
            if(typeof result == 'string'){
                if(Activiti.util.isJsonFormat(result)){
                    requestData = JSON.parse(result);
                }else{
                    requestData = result;
                }
            }else{
                requestData = result;
            }
            if(typeof call == "function"){
                call(requestData);
            }
        },
        error:function(e){
            call(false);
            console.log(e);
        },
        beforeSend: function(xhr) {
            xhr.setRequestHeader("userName", optionsCopy.userAccount);
        }
    });
};

export function ActData(){
    this.serverUrl = "/cm-sites-activiti/activitiPublic/";
    this.allGroupUrl = this.serverUrl + "getAllGroup";
    this.allRole = this.serverUrl + "getAllRole";
    this.getUsers = this.serverUrl + "getUsers";
}

/**
 * 获取所有的部门
 */
ActData.prototype.getAllGroup = function () {
    return this.post(this.allGroupUrl,null);
}
ActData.prototype.getAllRole = function () {
    return this.post(this.allRole,null);
}

ActData.prototype.getGroupByIds = function (ids) {
    let json = new Array();
    let data= this.getAllGroup();
    data.map(item =>{
        if(ids.indexOf(item.id) > -1){
            json.push(item);
        }
    });
    return json;
}

ActData.prototype.getRoleByIds = function (ids) {
    let json = new Array();
    let data= this.getAllRole();
    data.map(item =>{
        if(ids.indexOf(item.id) > -1){
            json.push({
                id:item.id,
                name:item.roleName
            });
        }
    });
    return json;
};

ActData.prototype.getUser = function (pram,activiti,call) {
    activiti.post(this.getUsers,JSON.stringify(pram),function(users){
        call(users);
    })
};


function ActChoose(){
}